import { CountryIndicator } from "@domain/currentProfile/countriesIndicators";
import { UserKyc } from "./userKyc";
import { UserKycApi } from "./userKycApi";
import { UserKycDraft } from "./userKycDraft";

export class UserKycService {
	// userKycStore = new SimpleStore((id) => this.userKycApi.getKyc(id));
	constructor(private readonly userKycApi: UserKycApi) {}

	async saveUserKyc(draft: UserKycDraft): Promise<UserKyc> {
		const userKyc = await this.userKycApi.create(draft);
		return userKyc;
	}

	async getKyc(): Promise<UserKyc> {
		const userKyc = await this.userKycApi.getKyc();
		return userKyc;
	}

	async checkNumber(indicative: CountryIndicator, phoneNumber: string): Promise<void> {
		await this.userKycApi.checkNumber(indicative, phoneNumber);
	}
	async checkCode(code: string): Promise<boolean> {
		const isChecked = await this.userKycApi.checkCode(code);
		return isChecked;
	}
}
